import { Injectable } from '@angular/core';
import {
  EpimsGenderDto,
  StateDto,
  LgaDto,
  CountryDto,
  ProjectTypeDto,
  ProjectCategoryDto,
  OilFieldDto,
  CommunityDto,
  OilBlockDto,
  ClusterDto,
  ClusterCommunityDto,
  DocumentCategoryDto,
  DocumentSubCategoryDto,
  CurrencyDto,
  GMOUDto,
} from '@cradua/data';

@Injectable({
  providedIn: 'root',
})
export class ProjectReferencesService {
  constructor() {}

  stateName(states: StateDto[], value) {
    return states.find((state) => state.id === value).StateName;
  }

  lgaName(lgas: LgaDto[], value) {
    return lgas.find((lga) => lga.id === value).LgaName;
  }

  countryName(countries: CountryDto[], value) {
    return countries.find((country) => country.id === value).CountryName;
  }

  clusterName(cluster: ClusterDto[], value) {
    return cluster.find((cluster) => cluster.id === value).ClusterName;
  }

  clusterCommunityName(clusterCommunity: ClusterCommunityDto[], value) {
    return clusterCommunity.find(
      (clusterCommunity) => clusterCommunity.id === value
    ).ClusterCommunityName;
  }

  gmouName(gmous: GMOUDto[], value) {
    return gmous.find((gmou) => gmou.id === value).GMOUTitle;
  }

  projectTypeName(projectType: ProjectTypeDto[], value) {
    return projectType.find((type) => type.id === value).ProjectTypeName;
  }

  projectCategoryName(projectCategory: ProjectCategoryDto[], value) {
    return projectCategory.find((category) => category.id === value)
      .ProjectCategoryName;
  }

  oilBlockName(oilBlock: OilBlockDto[], value) {
    return oilBlock.find((oilBlock) => oilBlock.id === value).OilBlockName;
  }

  oilFieldName(oilField: OilFieldDto[], value) {
    return oilField.find((session) => session.id === value).OilFieldName;
  }

  communityName(communities: CommunityDto[], value) {
    communities.find((community) => community.id === value).CommunityName;
  }

  documentCategoryName(documentCategory: DocumentCategoryDto[], value) {
    return documentCategory.find((doc) => doc.id === value)
      .DocumentCategoryName;
  }

  documentSubCategoryName(
    documentSubCategory: DocumentSubCategoryDto[],
    value
  ) {
    return documentSubCategory.find((doc) => doc.id === value)
      .DocumentSubCategoryName;
  }

  currencyName(currency: CurrencyDto[], value) {
    return currency.find((currency) => currency.id === value).CurrencyCode;
  }

  getLgaArray(lgas: LgaDto[], ids: string) {
    const returnSplit = ids.split(',');
    const selectedLga = lgas.filter((item) => returnSplit.includes(item.id));
    return selectedLga;
  }

  getStateArray(states: StateDto[], ids: string) {
    const returnSplit = ids.split(',');
    const selectedstates = states.filter((item) =>
      returnSplit.includes(item.id)
    );
    return selectedstates;
  }

  getOilFieldArray(oilFields: OilFieldDto[], ids: string) {
    const returnSplit = ids.split(',');
    const selectedOilFields = oilFields.filter((item) =>
      returnSplit.includes(item.id)
    );
    return selectedOilFields;
  }

  getOilBlockArray(oilBlocks: OilBlockDto[], ids: string) {
    const returnSplit = ids.split(',');
    const selectedOilBlocks = oilBlocks.filter((item) =>
      returnSplit.includes(item.id)
    );
    return selectedOilBlocks;
  }
}
